import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { MobileNav } from '../components/MobileNav';
export function WorkMirrorNote() {
  const navigate = useNavigate();
  const [note, setNote] = useState('');
  const [showContext, setShowContext] = useState(false);
  const [context, setContext] = useState('');
  const handleSave = () => {
    // Save note logic here
    // For now, just navigate back to app home
    navigate('/mirrors/work/app');
  };
  return <>
      <Helmet data-id="element-5002">
        <title data-id="element-5003">Note — Work Mirror | Lazy Monk Labs</title>
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-5004">
        <MobileNav data-id="element-5005" />

        <main className="pt-16 sm:pt-20 pb-12 sm:pb-16" data-id="element-5006">
          <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-5007">
            {/* Header */}
            <div className="py-5 sm:py-6 border-b border-[#2B2B2B]" data-id="element-5008">
              <p className="text-xs font-mono text-gray-600 uppercase tracking-wider" data-id="element-5009">
                Note
              </p>
              <p className="text-sm text-gray-500 mt-1" data-id="element-5010">
                Write anything. No structure required.
              </p>
            </div>

            {/* Note input */}
            <div className="mt-8 sm:mt-10" data-id="element-5011">
              <textarea value={note} onChange={e => setNote(e.target.value)} placeholder="" className="w-full min-h-[300px] bg-[#0A0A0A] border border-[#2B2B2B] text-[#F5F5F5] text-sm p-5 sm:p-6 focus:outline-none focus:border-[#F5F5F5] transition-colors resize-none" autoFocus data-id="element-5012" />
            </div>

            {/* Optional context */}
            {showContext && <div className="mt-4" data-id="element-5013">
                <input type="text" value={context} onChange={e => setContext(e.target.value)} placeholder="Add context (optional)" className="w-full bg-[#0A0A0A] border border-[#2B2B2B] text-[#F5F5F5] text-sm p-4 focus:outline-none focus:border-[#F5F5F5] transition-colors" data-id="element-5014" />
              </div>}

            {/* Actions */}
            <div className="mt-8 sm:mt-10 space-y-4" data-id="element-5015">
              <button onClick={handleSave} disabled={!note.trim()} className="block w-full p-4 border border-[#F5F5F5] bg-[#F5F5F5] text-[#0A0A0A] text-center text-xs font-medium uppercase tracking-wider hover:bg-gray-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#F5F5F5]" data-id="element-5016">
                Save note
              </button>

              {!showContext && <button onClick={() => setShowContext(true)} className="block w-full p-4 border border-[#2B2B2B] text-center text-xs font-medium text-gray-500 hover:text-[#F5F5F5] hover:border-[#F5F5F5] transition-all" data-id="element-5017">
                  Add context (optional)
                </button>}

              <button onClick={() => navigate('/mirrors/work/app')} className="block w-full p-4 text-center text-xs font-medium text-gray-600 hover:text-gray-400 transition-colors" data-id="element-5018">
                Cancel
              </button>
            </div>
          </div>
        </main>
      </div>
    </>;
}